export const DONOR_FILTER_TOOLBAR_CONTROL_CLASS =
  "border-border bg-background text-foreground shadow-sm " +
  "[&_svg:not([class*='text-'])]:text-muted-foreground " +
  "hover:bg-accent/50 dark:border-border dark:bg-card dark:text-card-foreground " +
  "dark:[&_svg:not([class*='text-'])]:text-card-foreground/80 dark:hover:bg-accent/40";

export const DONOR_FILTER_TOGGLE_SEGMENT_CLASS =
  "rounded-full border-0 px-3 py-1.5 text-xs shadow-none text-muted-foreground hover:bg-muted/80 hover:text-foreground data-[state=on]:bg-background data-[state=on]:text-foreground data-[state=on]:shadow-sm sm:px-4 sm:text-sm dark:data-[state=on]:bg-card dark:data-[state=on]:text-card-foreground";

export const DONOR_FILTER_TOGGLE_GROUP_CLASS =
  "gap-1 rounded-full bg-muted p-1";
